"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_1 = require("react");
var Declarative_1 = require("../utils/Declarative");
var DomWidgets_1 = require("./DomWidgets");
var ClickBusting_1 = require("../config/ClickBusting");
var Declarative_2 = require("../utils/Declarative");
var InputLabelWidget_1 = require("./InputLabelWidget");
var SwitcherTextGroupNamePrefix = 'SwitcherTextGroup';
/**
 * The SwitchTextButton is the individual button within a switcher.  It contains the text and
 * can be toggled.  The underlying input is a radio button.
 */
var SwitcherTextButton = /** @class */ (function (_super) {
    tslib_1.__extends(SwitcherTextButton, _super);
    function SwitcherTextButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            if (!_this.props.checked) {
                _this.props.handleChange(_this.props.idx);
            }
        };
        /**
         * If it is active, call the handleActive with the switcher's idx, otherwise return -1 to say
         * that it is no longer selected.
         */
        _this.handleActive = function (active) {
            _this.props.handleActive(active ? _this.props.idx : -1);
        };
        return _this;
    }
    SwitcherTextButton.prototype.render = function () {
        return (react_1.createElement(InputLabelWidget_1.InputLabelWidget, {
            style: this.props.style,
            testId: this.props.testId,
            interactiveStyles: {
                hover: this.props.hoverStyle,
                focus: this.props.focusStyle
            },
            handleActive: this.handleActive
        }, react_1.createElement('input', {
            style: {
                opacity: 0,
                position: 'absolute'
            },
            onChange: this.handleChange,
            type: 'radio',
            checked: this.props.checked,
            name: this.props.groupName,
            'data-tb-test-id': Declarative_2.testId(this.props.testId, 'input')
        }), this.props.children));
    };
    return SwitcherTextButton;
}(React.Component));
/**
 * The SwitchTextBase is the container of the switcher buttons.  It maintains the state of what
 * switcher button is active and creates the group id for the underlying radio buttons.
 */
var SwitcherTextBase = /** @class */ (function (_super) {
    tslib_1.__extends(SwitcherTextBase, _super);
    function SwitcherTextBase(props) {
        var _this = _super.call(this, props) || this;
        _this.handleActive = function (idx) {
            // TFSID 694578: prevent visual flicker on iOS when client is ClickBusting
            if (ClickBusting_1.ClickBustingConfig.suppressionClassName && ClickBusting_1.ClickBustingConfig.suppressionClassName.length) {
                return;
            }
            _this.setState({ activerSwitcherIdx: idx });
        };
        _this.groupId = SwitcherTextBase.groupIdIncrementor++;
        _this.state = { activerSwitcherIdx: -1 };
        return _this;
    }
    SwitcherTextBase.prototype.getToggleStyling = function (currentSwitcherIdx) {
        var hasActiveSwitcher = this.state.activerSwitcherIdx >= 0;
        var currentSwitcherIsFirst = currentSwitcherIdx === 0;
        var currentSwitcherIsLast = currentSwitcherIdx === this.props.toggleTexts.length - 1;
        var currentSwitcherInactive = this.state.activerSwitcherIdx !== currentSwitcherIdx;
        var currentSwitcherChecked = this.props.checkedIndex === currentSwitcherIdx;
        return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, this.props.style.toggleBase), Declarative_1.conditional(currentSwitcherIsFirst, this.props.style.firstToggle)), Declarative_1.conditional(currentSwitcherIsLast, this.props.style.lastToggle)), (hasActiveSwitcher ? (currentSwitcherInactive ? this.props.style.inactiveToggle :
            /* is active */ currentSwitcherChecked ? this.props.style.activeSelectedToggle : this.props.style.activeUnselectedToggle)
            /* no active */ : (currentSwitcherChecked ? this.props.style.selectedToggle : this.props.style.unselectedToggle)));
    };
    SwitcherTextBase.prototype.render = function () {
        var _this = this;
        var groupName = SwitcherTextGroupNamePrefix + String(this.groupId);
        var switchButtons = this.props.toggleTexts.map(function (toggleText, idx) {
            var toggleStyle = _this.getToggleStyling(idx);
            var hoverStyle = _this.props.checkedIndex === idx ? _this.props.style.hoverSelectedToggle : _this.props.style.hoverUnselectedToggle;
            var focusStyle = _this.props.checkedIndex === idx ? _this.props.style.focusSelectedToggle : _this.props.style.focusUnselectedToggle;
            return react_1.createElement(SwitcherTextButton, {
                groupName: _this.props.name || groupName,
                handleChange: _this.props.handleChange,
                checked: _this.props.checkedIndex === idx,
                testId: Declarative_2.testId(_this.props.testId, toggleText),
                idx: idx,
                style: toggleStyle,
                hoverStyle: hoverStyle,
                focusStyle: focusStyle,
                key: idx,
                handleActive: _this.handleActive
            }, toggleText);
        });
        return react_1.createElement(DomWidgets_1.Block, {
            style: this.props.style.container,
            className: ClickBusting_1.ClickBustingConfig.suppressionClassName,
            role: 'radiogroup',
            'aria-label': this.props.ariaLabel
        }, switchButtons);
    };
    SwitcherTextBase.groupIdIncrementor = 0;
    return SwitcherTextBase;
}(React.Component));
exports.SwitcherTextBase = SwitcherTextBase;
//# sourceMappingURL=SwitcherTextBase.js.map